// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"ItemTooltip--tooltip--1o","small":"ItemTooltip--small--32","body":"ItemTooltip--body--3d","header":"ItemTooltip--header--3D","description":"ItemTooltip--description--3_","itemAttributes":"ItemTooltip--itemAttributes--35","perks":"ItemTooltip--perks--3j","stats":"ItemTooltip--stats--YC","extraInfo":"ItemTooltip--extraInfo--2r","objectives":"ItemTooltip--objectives--11","section":"ItemTooltip--section--1_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ItemTooltip/styles.styl
// module id = 849
// module chunks = 0